<template>
  <nav id="gel-subpages" role="navigation" class="px-lg-5">
    <div class="container">
      <div class="row">
        <div class="offset-xl-1 col-xl-10 offset-xxl-2 col-xxl-8">
          <nav class="page-tabs nav" role="tablist">
        <li class="nav-item"
          v-for="(iconComponent, index) in navData.order"
          :key="iconComponent"
        >
            <a href="#" class="nav-link" :id="navData[iconComponent].name.toLowerCase().replace(' ', '-') + '-tab'" data-toggle="tab" role="tab" :aria-controls="navData[iconComponent].name.toLowerCase().replace(' ', '-')" 
            :class="{ active: (activeNavTab === '' && index === 0) || (activeNavTab === iconComponent) }"
            :aria-selected="activeNavTab === iconComponent ? 'true' : 'false'"
            @click="$emit('update-current-nav-tab', iconComponent)"
            >{{ navData[iconComponent].description }} <span v-if="navData[iconComponent].numberOfIcons > 0" class="badge badge-info text-sm">{{ navData[iconComponent].numberOfIcons }}</span>
            </a>
        </li>
          </nav>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Nav',
  computed: {
    activeNavTab: function () {
      return this.currentNavTab
    }
  },
  props: {
    navData: Object,
    currentNavTab: {
      default: '',
      type: String
    }
  }
}
</script>